<template>
    <div class="wrapper-landing">
      <LandingHero
        title="Erstelle deine kostenlose Baby-Wunschliste"
        subtitle="Füge die schönsten Geschenke für dein Baby aus jedem beliebigen Shop hinzu und teile deine liebevoll gestaltete Liste."
        origin="listabebe"
        lang="de-DE"
        buttonText="Wunschliste anlegen"
      >
        <template v-slot:cover>
          <source
            media="(max-width: 991px)"
            class=""
            srcset="../../assets/img/landings/cover-mujer-joven-embarazada-movil-resp.jpg"
            alt=""
            loading="lazy"
          />
          <img
            class="ln-hero__inset"
            src="../../assets/img/landings/cover-mujer-joven-embarazada-movil.jpg"
            alt=""
            loading="lazy"
          />
        </template>
      </LandingHero>
      <main class="bg-cercles">
        <LandingAppRatings />
  
        <section class="bb-container">
          <LandingFeaturesSimple title="Unsere Geburtsliste hilft dir, wenn:"
          :use-carousel="false"
          >
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-embarazada.svg" alt="" />
              </template>
              <template slot="title">
                Du frischgebackene Mama / Papa bist und noch nicht genau weißt, was du wirklich brauchst.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-q.svg" alt="" />
              </template>
              <template slot="title">
                Familie und Freunde dich ständig fragen, was ihr euch für euer Baby wünscht.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-mobile-cart.svg" alt="" />
              </template>
              <template slot="title"> Du Artikel aus beliebigen Shops hinzufügen möchtest. </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-hand-heart.svg" alt="" />
              </template>
              <template slot="title">
                Du nach einem einfachen und schönen Weg suchst, deine Wünsche zu teilen.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-clipboard.svg" alt="" />
              </template>
              <template slot="title">
                Du dich gerne organisierst und nichts vergessen willst.
              </template>
            </LandingFeaturesSimpleItem>
          </LandingFeaturesSimple>
        </section>
      </main>
  
      <LandingFeaturesCover title="Eine Liste voller guter Dinge">
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/cover-retailers-box-int.webp" alt="" />
          </template>
          <template slot="titulo">
            Wünsch dir jedes Modell und jede Marke aus jedem Shop
          </template>
  
          <template slot="descripcion">
            <p>
                Kopiere einfach jeden Link und füge ihn deiner Liste hinzu. Volle Freiheit, genau das auszuwählen, was du willst.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/cover-regalos-efectivo.svg" alt="" />
          </template>
          <template slot="titulo"> Erhalte Geld ohne Gebühren </template>
  
          <template slot="descripcion">
            <p>
                Deine Familie und Freunde können dir Wünsche erfüllen oder Geld schenken, damit du sie selbst besorgen kannst. 100 % gebührenfrei – für dich und deine Liebsten.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <FeaturesCoverItemListUpdate lang="de-DE" />
      </LandingFeaturesCover>
  
      <main class="bg-cercles">
        <section class="bb-container">
          <LandingReviews lang="de-DE" />
          <!-- <LandingHablan /> -->
        </section>
      </main>
  
      <LandingComoCols title="Wie funktioniert es?" subtitle="Deine Wunschliste ohne Grenzen">
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-click.svg" alt="" />
          </template>
          <template slot="titulo">Wähle, was du wirklich willst</template>
          <template slot="descripcion">
            <p>
                Wähle ein Produkt aus einem beliebigen Shop, kopiere den Link und füge ihn deiner Liste hinzu.
            </p>
            <p>
              Du kannst auch eine Spardose anlegen, um Geld für alles zu sammeln, was du möchtest.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-share.svg" alt="" />
          </template>
          <template slot="titulo">Teile deine Wünsche</template>
          <template slot="descripcion">
            <p>Teile deine Liste jederzeit mit deiner Familie und deinen Freunden.</p>
            <p>
                Schicke ihnen einen Link, damit sie von überall und ohne Registrierung auf deine schön personalisierte Liste zugreifen können.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-gift.svg" alt="" />
          </template>
          <template slot="titulo">Deine Wunschgeschenke erhalten</template>
          <template slot="descripcion">
            <p>
                Deine Liebsten können sich ein Geschenk aus deiner Liste aussuchen und es kaufen.
Sie können es direkt zu dir schicken oder zu sich nach Hause bestellen, um es dir später persönlich zu überreichen.
            </p>
            <p>
                Damit niemand dasselbe Geschenk doppelt kauft, können sie es in der Liste als "Gekauft" markieren.
            </p>
          </template>
        </LandingComoColsItem>
      </LandingComoCols>
  
      <LandingFooter lang="de-DE" />
    </div>
  </template>
  
  <script>
  import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";
  
  import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
  import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";
  
  import LandingHero from "./components/LandingHero.vue";
  import LandingAppRatings from "./components/LandingAppRatings.vue";
  import LandingFeaturesCover from "./components/LandingFeaturesCover";
  import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
  import LandingReviews from "./components/LandingReviews.vue";
  import LandingHablan from "./components/LandingHablan.vue";
  import LandingFooter from "./components/LandingFooter.vue";
  
  import LandingComoCards from "./components/LandingComoCards.vue";
  import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
  import LandingComoColsItem from "./components/LandingComoColsItem.vue";
  import LandingComoCols from "./components/LandingComoCols.vue";

  import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";

  // import bbButton from "../../components/buttons/bbButton.vue";
  
  export default {
    name: "LandingNoListDE",
    metaInfo() {
      return {
        title: "HelloBB – Deine perfekte Baby-Wunschliste",
        htmlAttrs: {
          lang: "de",
        },
        meta: [
          { name: "description", content: "HelloBB ist die Geburtsliste, in der all deine Wünsche Platz haben." },
          { name: "robots", content: "noindex" },
        ],
      };
    },
    components: {
      LandingComoCols,
      LandingComoColsItem,
      LandingAppRatings,
      LandingHablan,
      LandingReviews,
      LandingFooter,
      LandingHero,
      LandingFeaturesCover,
      LandingFeaturesCoverItem,
      LandingFeaturesSlider,
      LandingFeaturesSimple,
      LandingFeaturesSimpleItem,
      LandingComoCards,
      LandingComoCardsItem,
      FeaturesCoverItemListUpdate,
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  